import {
  EuiModal,
  EuiModalBody,
  EuiModalHeader,
  EuiModalHeaderTitle,
  EuiModalProps,
} from "@inscopix/ideas-eui";
import {
  CallOutError,
  CalloutErrorProps,
} from "components/CallOutError/CallOutError";

interface ModalErrorProps {
  title?: string;
  error?: string;
  onClose: EuiModalProps["onClose"];
}

/**
 * Displays an error modal
 */
export const ModalError = ({ title, error, onClose }: ModalErrorProps) => {
  const calloutProps: CalloutErrorProps =
    error !== undefined ? { message: error } : {};
  return (
    <EuiModal onClose={onClose}>
      <EuiModalHeader>
        <EuiModalHeaderTitle>{title ?? "Error"}</EuiModalHeaderTitle>
      </EuiModalHeader>

      <EuiModalBody>
        <CallOutError {...calloutProps} />
      </EuiModalBody>
    </EuiModal>
  );
};
